import { Injectable } from '@angular/core';
import { BaseService } from '../../../../shared/services/base.service';
import { MasterDataUrl } from '../../../../shared/urls/master-data.urls'
import { Utility } from '../../../../common/utility';
import { PatientUrl } from '../../../../shared/urls/patient.url'

@Injectable()
export class ClinicAccessService {
    constructor(public baseService: BaseService) {
    }

    getCountriesByBaseClinic(isBaseClinic:boolean){
        const url = MasterDataUrl.GET_COUNTRIES_DROPDOWNLIST_BY_BASECLINIC;       
        return this.baseService.getData(url,{isBaseClinic:isBaseClinic});
    }
    getCentresByBaseClinic(countryId:string, patientId:string, isBaseClinic:boolean){
        const url = Utility.stringFormat(MasterDataUrl.GET_CENTRES_COUNTRY,[countryId]);
        return this.baseService.getData(url,{patientId:patientId,isBaseClinic:isBaseClinic});
    }
    addPatientUserCentre(countryId:string, patientId:string,centreId:string[]){       
        const url = Utility.stringFormat(PatientUrl.ADD_USER_CENTRE_FOR_PATIENT,[patientId]) + "?countryId="+countryId;
        return this.baseService.postData(url,centreId);
    }
}




// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/centre/manage-patient-user/clinic-access/clinic-access.service.ts